/**
 * 판매 현황 차트 컴포넌트 (Bar Chart)
 */

import React from 'react';
import { Card } from 'react-bootstrap';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { SalesByHall, SalesByPackage } from '../../types/dashboard';
import './Chart.css';

interface SalesChartProps {
  salesByHall: SalesByHall[];
  salesByPackage: SalesByPackage[];
}

const SalesChart: React.FC<SalesChartProps> = ({ salesByHall, salesByPackage }) => {
  const formatCurrency = (value: number) => {
    if (value >= 1000000) {
      return `₩${(value / 1000000).toFixed(1)}M`;
    } else if (value >= 1000) {
      return `₩${(value / 1000).toFixed(0)}K`;
    }
    return `₩${value}`;
  };

  // 데이터 변환: 관별과 패키지별 데이터를 하나의 차트로 통합
  const chartData = React.useMemo(() => {
    const maxLength = Math.max(salesByHall.length, salesByPackage.length);
    const data = [];
    
    for (let i = 0; i < maxLength; i++) {
      data.push({
        name: salesByHall[i]?.hall_name || salesByPackage[i]?.package_name || `항목 ${i + 1}`,
        hall: salesByHall[i]?.sales || 0,
        package: salesByPackage[i]?.sales || 0,
      });
    }
    
    return data;
  }, [salesByHall, salesByPackage]);

  return (
    <Card className="chart-card">
      <Card.Body>
        <Card.Title className="chart-title">관별/패키지별 판매 현황</Card.Title>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 255, 255, 0.1)" />
            <XAxis
              dataKey="name"
              stroke="#CCCCCC"
              style={{ fontSize: '12px' }}
            />
            <YAxis
              stroke="#CCCCCC"
              style={{ fontSize: '12px' }}
              tickFormatter={formatCurrency}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'var(--color-blue-gray)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '8px',
                color: '#fff',
              }}
              formatter={(value: number) => formatCurrency(value)}
            />
            <Legend />
            <Bar dataKey="hall" fill="#00BCD4" name="관별 판매" />
            <Bar dataKey="package" fill="#3A4B5C" name="패키지별 판매" />
          </BarChart>
        </ResponsiveContainer>
      </Card.Body>
    </Card>
  );
};

export default SalesChart;

